import { render, staticRenderFns } from "./AlumnoBuscar.vue?vue&type=template&id=a72470fe&"
import script from "./AlumnoBuscar.vue?vue&type=script&lang=js&"
export * from "./AlumnoBuscar.vue?vue&type=script&lang=js&"
import style0 from "./AlumnoBuscar.vue?vue&type=style&index=0&id=a72470fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports